import React from 'react';
import './GeneralDocs.css'; 
import gesturesRacingGame from '../assets/gestures_racinggame.png';
import gesturesNavigateWeb from '../assets/gestures_navigateweb.png';
import gesturesSplitLead from '../assets/gestures_splitlead.png';
import gesturesKeyboard from '../assets/keyboard_gestures.png';


const ModesGestures = () => {
  return (
    <div className="docs-page-container">
      <h1>Gestures Modes Examples</h1>

      <h2>An approach to a Keyboard mode</h2>
      <p>
        My personal approach to be able to use all the keyboard inputs effectively takes advantage of
        mechanography rules: The keyboard can be splited in the keys you press with your left hand and the keys you press with 
        your right hand, and it also can be splited in rows. If we split the keyboard in 6, that is, 3 rows for each hand,
        then most of the single keys will be able to be mapped to a instruction of no more than 2 inputs (in case we have 
        6 or more gestures recorded).
        </p>
        <p>
        My approach is to assign the first input to the hand and row, and the second input to the finger number that
        presses the key. The special keys will have a single input instruction. 
        Here is a visual representation of the approach for a QWERTY keyboard and 6 gestures:
        </p>
      <img src={gesturesKeyboard} alt="Custom Mode Example" className="gestures-keyboard-image" />
      <p>
        The special key (space, enter, backspace, shift, tab, command, alt/option, control...) can mostly be assiged to 
        a one input instruction. As an example, if shift is assiged to gesture 1, then a combination of shift+character
        can be a 3 input instruction. This way, if "a" is 34, then "A" (shift+a) will be 134.
      </p>

      <h2> SplitLead + Mouse</h2>
      <p> A SplitLead mode with all the normal functionalities of a mouse</p>
      <img src={gesturesSplitLead} alt="Custom Mode Example" className="mode-image" />
      
      <h2> Racing Game</h2>
      <p> A mode that stores all the inputs that are normally used on a Racing Game. In order to achieve low latency,
        you can create a custom configuration to reduce the Seconds to run an intruction for this mode.
      </p>
      <img src={gesturesRacingGame} alt="Custom Mode Example" className="mode-image" />

      <h2> Navigate Web</h2>
      <p> A mode  with all the necessary to use a web browser, like mouse functionalities or special keys to 
        enable full screen, change tabs, close tabs...
      </p>
      <img src={gesturesNavigateWeb} alt="Custom Mode Example" className="mode-image" />

    </div>
  );
};

export default ModesGestures;
